import { render, staticRenderFns } from "./AvatarReminder.vue?vue&type=template&id=d53545d0&scoped=true&"
import script from "./AvatarReminder.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarReminder.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53545d0",
  null
  
)

export default component.exports